<template>
  <div style="height: 100vh;">
    <div class="login-container">
      <!--登录面板内容部分-->
      <div class="login-inner">
        <!--面板头部-->
        <div class="login-header">
          <div class="login-logo">
            <span v-if="getActivityId === 9" style="font-size:18px;font-weight:bold;">盐田公安分局2025年中秋节慰问活动</span>
            <span v-else-if="getActivityId === 13" style="font-size:18px;font-weight:bold;">东西优选消费帮扶兑换专区</span>
            <span v-else-if="getActivityId === 16" style="font-size:18px;font-weight:bold;">布吉水司元旦过节物品</span>
            <img v-else
              src="https://img.zhujiaxian.com/2024/09/07ab20ed60364cb7a46a3ea2f828227c.png"
              alt=""
            />
          </div>
          <!--面板标题-->
          <div class="login-header-title">
          </div>
        </div>
        <!--面板表单部分-->
        <div class="login-content">
          <form>
            <!--手机验证码登录部分-->
            <div :class="{ current: loginMode }">
              <section class="login-message">
                <label>
                  <input
                    type="text"
                    maxlength="11"
                    placeholder="手机号"
                    v-model="phone"
                  />
                </label>
                <button
                  v-if="!countDown"
                  class="get-verification"
                  :class="{ phone_right: phoneRight }"
                  @click.prevent="getCode()"
                >
                  获取验证码
                </button>
                <button v-else disabled="disabled" class="get-verification">
                  已发送({{ countDown }}s)
                </button>
              </section>
              <section class="login-verification">
                <label>
                  <input
                    type="text"
                    maxlength="8"
                    placeholder="验证码"
                    v-model="code"
                  />
                </label>
              </section>
              <!-- 根据activityId条件显示不同内容 -->
              <section v-if="getActivityId !== 10" class="login-hint" style="color:red;">
                请使用单位登记的手机号码进行登陆
              </section>
              <section v-else class="login-hint" style="color:red;">
                <a href="javascript:;">服务协议与隐私政策</a> 
              </section>
              <button class="login-submit" @click.prevent="registerNext">
                登录
              </button>
            </div>

            <!--微信登录授权部分-->
            <div :class="{ current: !loginMode }">
              <button class="login-submit" @click.prevent="WXlogin">
                点击微信登录
              </button>
            </div>
          </form>
          <!-- <button class="login-back" @click.prevent="back">返回</button> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  GetregistOrLogin,
  GetsmsregistOrLogin,
  getOpenids,
} from "@/https/http.js";
import { mapGetters, mapActions } from 'vuex';
export default {
  data() {
    return {
        show: true,
        count: null,
        errorTips: 0,
        timer: null,
        phone: "",
        code: "",
        countDown: 0,  // 4. 倒计时
        loginMode: true, // 1. 登录模式
      };
  },
  computed: {
    ...mapGetters([
      'getActivityId'
    ]),
    phoneRight() {
      // 验证手机号码是否正确
      return /^[1][3,4,5,7,6,8,9][0-9]{9}$/.test(this.phone);
    },
  },
  created() {
   // 优先从全局store获取activityId
  // const globalActivityId = this.getActivityId;
  //  if (globalActivityId) {
  //    // store中已有activityId，直接使用
  //  } else {
  //    // store中没有，则从URL参数获取
  //    const activityIdParam = this.getUrlParam('activityId');
  //    if (activityIdParam) {
  //      // 将从URL获取的activityId更新到全局store
  //      this.updateActivityId(parseInt(activityIdParam));
  //    } else {
  //      // 默认设置为10，并更新到全局store
  //      this.updateActivityId(10);
  //    }
  //  }
  //this.getAuthorize();
  },
  methods: {
    ...mapActions([
      'updateActivityId'
    ]),
    getAuthorize() {
      // 此方法用来判断是不是在微信中打开
      const isWechat = () => {
        let ua = window.navigator.userAgent.toLowerCase();
        return ua.match(/MicroMessenger/i) == "micromessenger";
      };
      //是微信中打开，则进行一  下操作
      if (isWechat) {
        //先判断有没有授权(判断地址栏code，有就-用户同意了授权，没有-没授权或者拒绝授权)
        var str = this.getUrlParam("code"); //此处使用的是history路由模式，hash这么拿不到。this.getUrlParam()方法在下面
        console.log("获取到了 ", str);
        if (str) {
          getOpenids(str).then((result) => {
            console.log(result, "result");
            console.log(result.data, "openid");
            window.localStorage.setItem("openID", result.data.openid);
            console.log(result.data.openid, "result.openid");
          });
        } else {
          var appid = "wx2fdbabccb9206fec";
          var redirect_uri = window.location.href;
          
          var newRedirect = encodeURIComponent(redirect_uri); // 此处需要将你的回调页面进行转码，此方法直接使用
          console.log(newRedirect,'newRedirect');
          window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            appid +
            "&redirect_uri=" +
            newRedirect +
            "&response_type=code&scope=snsapi_base&state=123#wechat_redirect";
        }
      }
    },
    //获取url中的参数
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象 
      var r = window.location.search.substr(1).match(reg); //匹配目标参数
      if (r != null) {
        return unescape(r[2]);
      }
      return null; //返回参数值
    },

    //截取code码
    GetParam(url, code) {
      this.$toast.fail(code, url);
      url = url + "";
      let regstr = "/(\\?|\\&)" + code + "=([^\\&]+)/";
      let reg = eval(regstr);
      //eval可以将 regstr字符串转换为 正则表达式
      let result = url.match(reg);
      if (result && result[2]) {
        return result[2];
      }
    },
    onClickLeft() {
      this.$router.push({ path: "/home" });
    },
    //获取验证码
    getCode() {
      if (this.phoneRight) {
        // 4.1 过滤
        let data = {
          phoneNumber: this.phone,
        };
        // 传递当前活动ID作为h5MallId参数
        if (this.getActivityId !== 8 && this.getActivityId !== 10) {
          data.h5MallId = this.getActivityId;
        } 
        this.countDown = 60;
        // 4.2 倒计时
        this.intervalId = setInterval(() => {
          this.countDown--;
          if (this.countDown === 0) {
            clearInterval(this.intervalId);
          }
        }, 1000);
        GetsmsregistOrLogin(data).then((res) => {
          console.log(res);
          // const timeCount = 60;
          // if (!this.timer) {
          //   let count = timeCount;
          //   let timer = this.timer;
          //   setTimeout(() => {
          //     console.log("setTimeout");
          //     this.count = count;
          //     this.show = false;
          //   }, 1000);
          //   timer = setInterval(() => {
          //     if (this.count > 0 && this.count <= timeCount) {
          //       this.count--;
          //       console.log("进来了");
          //     } else {
          //       clearInterval(timer);
          //       console.log("出去了");
          //       this.timer = null;
          //       this.show = true;
          //     }
          //   }, 1000);
          // }
        });
      }
    },
    //登陆
    registerNext() {
      let data = {
        mobile: this.phone,
        validCode: this.code,
      };
      // 传递当前活动ID作为h5MallId参数
      if (this.getActivityId !== 8 && this.getActivityId !== 10) {
        data.h5MallId = this.getActivityId;
      } 
      GetregistOrLogin(data)
        .then((res) => {
          console.log(res);
          if (res.data.access_token) {
            this.$toast.success("登录成功");
            localStorage.setItem(
              "token",
              res.data.token_type + res.data.access_token
            );
            this.$router.push({ path: "/User" });
          }
        })
        .catch((error) => {
          // 处理错误
          console.error("请求失败", error);
          this.$toast.fail(error.data);
        });
    },
  },
};
</script>
<style lang="less" scoped>
.con {
  margin-top: 50px;
  img {
    display: block;
    width: 75px;
    height: 75px;
    margin: auto;
    border-radius: 50%;
    margin-bottom: 15%;
  }
  .login-form {
    width: 90%;
    margin: 0 auto;
    margin-bottom: 20%;
  }
  .item {
    display: block;
    margin-bottom: 15px;
    .error {
      .error-text {
        display: block;
        width: 100%;
        font-size: 28rpx;
        color: #e43130;
        text-align: left;
      }
    }
    .account {
      display: flex;
      background: #f8f8f8;
      padding: 7px;
      box-sizing: border-box;
      font-size: 13px;
      align-items: center;
    }
    input {
      padding-left: 10px;
      width: 70%;
      border: 0px;
      background: #f8f8f8;
    }
    .get-yzmget {
      border: 1px solid green;
      font-size: 12px;
      padding: 5px 10px;
      border-radius: 5px;
    }
    .get-yzm {
      display: inline-block;
      width: 25%;
      text-align: center;
    }
  }
  .authorized-btn {
    width: 90%;
    margin: 0 auto;
    text-align: center;
    background-color: #0ab906;
    border: 1px solid #0ab906;
    color: #fff;
    border-radius: 3px;
    font-size: 13px;
    padding: 4px;
    margin-top: 40px;
    line-height: 25px;
  }
  .to-idx-btn {
    width: 90%;
    margin: 0 auto;
    text-align: center;
    background-color: #eeeeee;
    border: 1px solid #eeeeee;
    color: #333;
    border-radius: 3px;
    font-size: 13px;
    padding: 4px;
    margin-top: 15px;
    line-height: 25px;
  }
}
.login-container {
  width: 100%;
  height: 100%;
  background: #fff;
}

.login-container .login-inner {
  padding-top: 60px;
  width: 80%;
  margin: 0 auto;
}

.login-container .login-inner .login-header .login-logo {
  font-size: 40px;
  font-weight: bold;
  color: #75a342;
  text-align: center;
}

.login-container .login-inner .login-header .login-header-title {
  padding-top: 40px;
  padding-bottom: 10px;
  text-align: center;
}

.login-container .login-inner .login-header .login-header-title > a {
  color: #333;
  font-size: 14px;
  padding-bottom: 4px;
  text-decoration: none;
}

.login-container
  .login-inner
  .login-header
  .login-header-title
  > a:first-child {
  margin-right: 40px;
}

.login-container .login-inner .login-header .login-header-title > a.current {
  color: #75a342;
  font-weight: 700;
  border-bottom: 2px solid #75a342;
}

.login-container .login-inner .login-content > form > div {
  display: none;
}

.login-container .login-inner .login-content > form > div.current {
  display: block;
}

.login-container .login-inner .login-content > form > div input {
  width: 100%;
  height: 100%;
  padding-left: 8px;
  box-sizing: border-box;
  border: 1px solid #ddd;
  border-radius: 4px;
  outline: 0;
  font: 400 14px Arial;
}

.login-container .login-inner .login-content > form > div input:focus {
  border: 1px solid #75a342;
}

.login-container .login-inner .login-content > form > div .login-message {
  position: relative;
  margin-top: 16px;
  height: 48px;
  font-size: 14px;
  background: #fff;
}

.login-container
  .login-inner
  .login-content
  > form
  > div
  .login-message
  .get-verification {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  border: 0;
  color: #ccc;
  font-size: 14px;
  background: transparent;
}

.login-container
  .login-inner
  .login-content
  > form
  > div
  .login-message
  .get-verification.phone_right {
  color: #75a342;
}

.login-container .login-inner .login-content > form > div .login-verification {
  position: relative;
  margin-top: 16px;
  height: 48px;
  font-size: 14px;
  background: #fff;
}

.login-container
  .login-inner
  .login-content
  > form
  > div
  .login-verification
  .switch-show {
  position: absolute;
  right: 10px;
  top: 12px;
}

.login-container
  .login-inner
  .login-content
  > form
  > div
  .login-verification
  .switch-show
  img {
  display: none;
}

.login-container
  .login-inner
  .login-content
  > form
  > div
  .login-verification
  .switch-show
  img.on {
  display: block;
}

.login-container .login-inner .login-content > form > div .login-hint {
  margin-top: 12px;
  color: #999;
  font-size: 12px;
  line-height: 20px;
}

.login-container .login-inner .login-content > form > div .login-hint > a {
  color: #75a342;
}

.login-container .login-inner .login-content > form .login-submit {
  display: block;
  width: 100%;
  height: 42px;
  margin-top: 30px;
  border-radius: 4px;
  background: #75a342;
  color: #fff;
  text-align: center;
  font-size: 16px;
  line-height: 42px;
  border: 0;
}

.login-container .login-inner .login-content .login-back {
  display: block;
  width: 100%;
  height: 42px;
  margin-top: 15px;
  border-radius: 4px;
  background: transparent;
  border: 1px solid #75a342;
  color: #75a342;
  text-align: center;
  font-size: 16px;
  line-height: 42px;
}
</style>
